import { render, staticRenderFns } from "./dfpdashboard.vue?vue&type=template&id=177a6104&"
import script from "./dfpdashboard.vue?vue&type=script&lang=js&"
export * from "./dfpdashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports